import { friendlyFormatIBAN } from 'ibantools';
import type { NgrxValueConverter } from 'ngrx-forms';

export type IBANConverter = NgrxValueConverter<string | null, string | null>;

export const ibanConverter: IBANConverter = {
  convertViewToStateValue: (value: string) => friendlyFormatIBAN(value),
  convertStateToViewValue: (value: string) => friendlyFormatIBAN(value),
};
